var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-card',{staticClass:"form-footer",attrs:{"title":"Acties","bordered":false}},[_c('a-row',[_c('a-col',{attrs:{"span":24}},[_c('a-row',{staticClass:"form-footer-row",attrs:{"type":"flex","align":"top"}},[_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.saveForm}},[_vm._v("Opslaan")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }